
import Vue from "vue";
import { differenceInDays, parseISO } from "date-fns";
export default Vue.extend({
  name: "is-banned-column",
  props: {
    row: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    dayNoun(days: number) {
      return days > 1 ? "days" : "day";
    }
  },
  computed: {
    indicatorClass(): string {
      return this.row.isBanned ? "bg-red-500" : "bg-green-500";
    },
    title(): string {
      return this.isRestricted ? "YES" : "NO";
    },
    type(): string {
      return this.isRestricted ? "danger" : "success";
    },

    isRestricted() {
      const restriction = this.row.isRestricted;

      if (!restriction || Object.keys(restriction).length === 0) {
        return false;
      }

      const now = new Date();
      const startDate = parseISO(restriction.startDate);
      const endDate = parseISO(restriction.endDate);

      const hasStarted = differenceInDays(now, startDate) >= 0;
      const notEnded = differenceInDays(endDate, now) >= 0;

      return hasStarted && notEnded;
    },
    totalRestrictedDays(): number {
      return differenceInDays(
        parseISO(this.row.isRestricted.endDate),
        parseISO(this.row.isRestricted.startDate)
      );
    },
    restrictedToolTipContent(): string {
      return `Restricted for ${this.totalRestrictedDays} ${this.dayNoun(
        this.totalRestrictedDays
      )}`;
    }
  }
});
